import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTiffToJpegConfig } from '@/data/landingConfig/landingTiffToJpegConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TiffToJpeg } from './schemaObject';

interface Props {}
const TiffToJpegConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TiffToJpeg} />
			<LandingTemplate
				data={landingTiffToJpegConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default TiffToJpegConverter;
